import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close_left",
  "use": "icon-close_left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" id=\"icon-close_left\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"m7 12 7 7m-7-7 7-7\" stroke-linejoin=\"round\" /><path d=\"M21 12H7.5\" /><path d=\"M3 3v18\" stroke-linejoin=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol